
import { Component, Vue, Ref, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import CourseCard from './views/CourseCard/index.vue'
import MyLayout from '../views/MyLayout/index.vue'
import WxImgPop, { type WxImgPopOptionType } from '../views/WxImgPop/index.vue'
import type { CourseCardUIType } from '@xt/client/entities/my-v2/types'
import type { CourseItem } from '@xt/client/types/my-go-course'
import { myCourseMenu } from '@xt/client/dataSource/my/index'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'
import { EnumOpenMiniProgramPage, EnumOpenMiniProgramType, EnumProductTypeQuery, EnumProductType } from '@xt/client/enums'
import JoinClassPopup from '@xt/www/components/joinClassPopup/index.vue'
import { EnumApiMy } from '@xt/client'

@Observer
@Component({
  scrollToTop: true,
  components: {
    MyLayout,
    EmptyStatus,
    CourseCard,
    WxImgPop,
    JoinClassPopup
  },
  async asyncData(ctx) {
    // 格式化合并路由参数
    const filterForm = ctx.store.$myV2.Course.parserQuery(ctx.query)
    // 初始化数据
    await ctx.store.$myV2.Course.loadMyProductList()

    return {
      filterForm
    }
  }
})
export default class MyCoursePage extends Vue {
  filterForm: {
    // 课程分类
    courseType: string
    // 菜单分类
    menuType: string
  }

  @Ref()
  wxImgPop: {
    openPop: (option: WxImgPopOptionType) => void
    hidePop: () => void
  }

  joinData: {
    visible: boolean
    qrcodeUrl: string
    productId: string
  } = {
    visible: false,
    qrcodeUrl: '',
    productId: ''
  }
  courseItem: (CourseItem & CourseCardUIType) | null = null
  //默认点击去学习都显示不在提醒
  hasShowCallAlert: boolean = false

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  // 内容区筛选项变化
  get filterLabels() {
    return myCourseMenu.find(item => item.value === this.filterForm.menuType)?.filters || []
  }

  get MyStore() {
    return this.$store.$myV2.Course
  }

  get myCourseMenu() {
    return myCourseMenu
  }

  hideJoinClassPop() {
    this.joinData.visible = false
  }

  // 调用接口同步数据是否提醒状态
  async changeGroupStatus(productId: string) {
    const res = await this.$ajax.put(EnumApiMy.changeGroupStatus, { productId })
    if (res == true) {
      this.hasShowCallAlert = true
    }
  }

  // 卡片点击去学习
  async handleGoLearn(item: CourseItem & CourseCardUIType) {
    this.courseItem = {
      ...item
    }
    const { type, bizId, groupChatStatus, showAssistantUrlFlag, assistantUrl, id } = item

    //如果是直播课，未入群未确认，弹窗;否则跳转
    if (type !== EnumProductTypeQuery.Exhibition && type !== EnumProductTypeQuery.DayCourse) {
      this.$router.push({
        path: `/course/${bizId}`
      })
      return
    }

    if (groupChatStatus == 2 || groupChatStatus == 1 || this.hasShowCallAlert || !showAssistantUrlFlag) {
      this.goLearnCheck()
      return
    }

    this.joinData = {
      visible: true,
      qrcodeUrl: assistantUrl[0],
      productId: id.toString()
    }
  }

  // 加群弹窗点击去学习
  async handleJoinGoLearn(callMe: boolean) {
    //如果是选中了不在提醒
    if (callMe === true) {
      this.changeGroupStatus(this.joinData.productId)
    }

    await this.goLearnCheck()
  }

  // 去学习逻辑判断
  async goLearnCheck() {
    if (!this.courseItem) return

    const { type, bizId, btnText, productType } = this.courseItem

    if (type == EnumProductTypeQuery.Exhibition) {
      let qrcodeUrl: string = ''
      if (btnText === '去备展') {
        qrcodeUrl = await this.$store.$storeShow.getQrcodeUrl({
          page: 'pages/levels/index',
          query: `id=${bizId}`
        })
      } else {
        qrcodeUrl = await this.$store.$storeShow.getQrcodeUrl({
          page: 'pages/lookingEx/index',
          query: `id=${bizId}`
        })
      }
      this.wxImgPop.openPop({
        courseType: 'show',
        qrcodeUrl,
        openMiniProgramOption: {
          miniProgrmType: EnumOpenMiniProgramType.Show,
          path: btnText === '去备展' ? EnumOpenMiniProgramPage.ShowLevels : EnumOpenMiniProgramPage.ShowLookingEx,
          query: {
            id: bizId
          }
        }
      })
    }

    if (type == EnumProductTypeQuery.DayCourse) {
      this.wxImgPop.openPop({
        courseType: 'day',
        qrcodeUrl: this.ossProcessImg(this.$images.xt_daily_mini, 288, 288, true),
        openMiniProgramOption: { miniProgrmType: EnumOpenMiniProgramType.DayCourse, path: EnumOpenMiniProgramPage.DayCourse }
      })
    }
  }

  // 更新筛选条件
  updateFilterForm(
    item: Partial<{
      courseType: string
      menuType: string
    }>
  ) {
    this.filterForm = {
      ...this.filterForm,
      ...item
    }

    document.documentElement.scrollTo({ top: 0 })
  }

  // 点击内容区筛选项
  handleFilterChange(key: string) {
    if (this.filterForm.courseType === key) return

    this.updateFilterForm({
      courseType: key
    })

    this.MyStore.changeFilterList(this.filterForm)
  }

  // 点击左侧菜单项
  handleMenuChange(key: string) {
    if (this.filterForm.menuType === key) return

    this.updateFilterForm({
      menuType: key,
      courseType: ''
    })
    this.MyStore.changeFilterList(this.filterForm)
  }

  created(): void {
    this.MyStore.changeFilterList(this.filterForm)
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {
    this.MyStore.reset()
  }
}
